/* eslint-disable camelcase, no-console */
import I18n from "../utils/I18n";
import SlotsConfig from "./slots-config";
import MediaQueries from "../utils/MediaQueries";
import '../utils/SmartResize';
//
// // On wort views, we have placed "dc-ad" divs on multiple pages that corresponds to the ads we want (defined by Regie on Google Ads Manager).
// // These divs have as attributes all the needed parameters to be able to define a google tag slot.
// // This script will look for these divs on the page, extract the needed params and define/create and push google tags slots.
// // doc: https://developers.google.com/publisher-tag/reference
//
// const lazyLoadThreshold = 300;
//
// // To debug with DFP console add this param in site url : ?google_force_console=1
// if(!window.console) window.console = {log: function(){}};
//
// window.googletag = window.googletag || {};
// var googletag = window.googletag;
// googletag.cmd = googletag.cmd || [];

window.kaching = window.kaching || {};
var kaching = window.kaching;
window.kachingConfig = window.kachingConfig || {};
var kachingConfig = window.kachingConfig;

//
// // to debug add this param in site url: ?pbjs_debug=true
// // to debug appnexus requests, find them in chrome debugger and append those parameters to the end: &debug_member=3646&dongle=blue
// var ads_debug_flag = false;
// if (window.location.search.indexOf("ads_debug=true") !== -1) {
//     ads_debug_flag = true;
// }
//
// // we log only if the ?ads_debug parameter is true
// var ads_debug = function(...args) {
//     if((ads_debug_flag) && (window.console)) {
//         console.log(...args);
//     }
// };
//
// function defineSlot(id, contentKw, adFormat, adFormatName, adUnit, adPos, lang) {
//
//     ads_debug("defineSlot - format:", adFormatName, ", pos:", adPos);
//
//     // googletag.defineSlot: Constructs an ad slot with a given ad unit path (adUnit)
//     // and size (adFormat.size) and associates it with the ID of a div element (id) on the page that will contain the ad.
//     // ex: googletag.defineSlot('/1234567/sports', [728, 90], 'div-1');
//     // returns: The newly created slot.
//     let gTag = googletag.defineSlot(adUnit, adFormat.size, id)
//     if (gTag) {
//         // googletag.pubads() : Returns a reference to the pubads service.
//         // pubads service = Publisher Ads service = service used to fetch and show ads from your Google Ad Manager account.
//         gTag.addService(googletag.pubads()) // Add the pubads service to the slot
//             .setTargeting("language", lang)
//             .setCollapseEmptyDiv(true, true);
//         if (adFormat.safeFrameConfig !== undefined) {
//             gTag.setSafeFrameConfig(adFormat.safeFrameConfig);
//         }
//         if (adFormat.withCompanion) {
//             gTag.addService(googletag.companionAds());
//         }
//         // Create responsive Ads: The mapping function ensures that the correct sized ad request is made to Ad Manager based on the screen size of the device making the request.
//         let respConfig = SlotsConfig.responsiveSizes[adFormat.responsive];
//         if (respConfig) {
//             let mapping = googletag.sizeMapping();
//             respConfig.forEach(size => {
//                 mapping = mapping.addSize(size[1], size[0]);
//         })
//             ;
//             mapping = mapping.build();
//             gTag.defineSizeMapping(mapping);
//         }
//
//         // Sets a custom targeting parameter for this slot. These keys are defined in your Google Ad Manager account.
//         gTag.setTargeting("pos", adPos);
//         gTag.setTargeting("device", MediaQueries.device());
//         if (contentKw !== undefined) {
//             gTag.setTargeting("kw", contentKw);
//         }
//     } else {
//         console.error(id + " is not defined");
//     }
//
//     return gTag;
// }
//
 $(document).ready(function() {
//
//     ads_debug("loadAds");
     let editionId = $('body').attr('data-edition-id');
     let isVideoArticle = $(".article-content--video-article ")[0]
//

//         // Don't use import for lazy load because vanilla-lazyload library is referring to the document body
//         // without waiting for the document to be ready, so it can be null...
//         const LazyLoad = require("vanilla-lazyload/dist/lazyload.min");
//
         let lang = I18n.lang();
         let slotsToDisplay = [];
         let slotsToLazyLoad = [];
         let definedSlotsById = {};

         // find all the dc-ad divs in the page
         let dfpslots = $("body").find(".dc-ad");
         var adUnit = $("body").find(".dc-ad:first").attr('data-adunit');
//
//         function lazyLoadAds() {
//
//             try {
//                 // Lazy load some ads
//                 slotsToLazyLoad.forEach(slot => {
//                     new LazyLoad({
//                         elements_selector: `#${slot.id}-container`,
//                         threshold: lazyLoadThreshold,
//                         callback_enter: () => {
//                             googletag.cmd.push(function() {
//                                 ads_debug("lazyload ad:", slot.id);
//                                 definedSlotsById[slot.id] = slot.defineSlot();
//                                 googletag.display(slot.id);
//                                 googletag.pubads().refresh([definedSlotsById[slot.id]]);
//                                 // a11y
//                                 $('#'+slot.id+ ' iframe').attr('tabindex', '-1');
//                             });
//                         }
//                     })
//                 });
//
//             } catch(e) {
//                 console.error(e);
//                 googletag.cmd.push(function() {
//                     googletag.pubads().refresh();
//                 });
//             }
//         }
//
         // extract params from the dc-ad divs found on the page, params needed to prepare slots definition
         $(dfpslots)
         if(dfpslots.length || isVideoArticle) {
             $(dfpslots).each(function() {

                 $(this).empty();
                 var id = $(this).attr('id'); // ex: div-gpt-ad-123456-leaderboard-t1
                 //var contentKw = $(this).attr('data-kw');
                 var adFormatName = $(this).attr('data-adformat'); // ex: leaderboard
                 //var adUnit = $(this).attr('data-adunit'); // ex: WortV4.test/home  // not needed at the slot level
                 var adPos = $(this).attr('data-adpos'); // ex: t1
                 var lazy = $(this).attr('data-lazy'); // ex: true
                 //var adFormat = SlotsConfig.dfpFormats[adFormatName]; // not needed anymore

                 kaching.defineSlot(
                     adFormatName,
                     adPos,
                     {
                         el: '#'+id,
                         group: id.indexOf("leaderboard-t1") >= 0 || id.indexOf("rectangle-b1") >= 0  ? 'roadblock':'',
                         targeting: {
                             pos: adPos
                         }
                     }
                 );
//
//                 //console.log("----->slot:" + id + " kw=" + contentKw);
//
//                 if(adFormat) {
//                     let slotDefinition = {
//                         id,
//                         defineSlot: () => defineSlot(id, contentKw, adFormat, adFormatName, adUnit, adPos, lang)
//                     }
//                     if(lazy === "true") {
//                         // if we are on desktop we avoid lazyloading roadblock positions
//                         if (MediaQueries.isDesktop()) {
//                             if (SlotsConfig.roadblockPositions.indexOf(adPos) === -1) {
//                                 slotsToLazyLoad.push(slotDefinition);
//                             } else {
//                                 slotsToDisplay.push(slotDefinition);
//                             }
//                         } else {
//                             slotsToLazyLoad.push(slotDefinition);
//                         }
//                     } else {
//                         slotsToDisplay.push(slotDefinition);
//                     }
//                 } else {
//                     ads_debug("Ad format not found for: "+id)
//                 }
             });

             kaching.init({
                 adunit: adUnit,
                 page: {
                     paid: kachingConfig['pw'],
                     taglist: kachingConfig['ads_keywords']
                 },
                 personalAds: true, // note: This value is obsolete when using a TCF2 Consent string
                 platform: 'WWW',
                 targeting: {
                     page_type: kachingConfig['traffic_tag'],
                     lang: lang,
                     language: lang,
                     article_taglist: kachingConfig['ads_keywords'],
                     kw: kachingConfig['ads_keywords']
                 }
             })

             document.addEventListener('KaChing.render.init', event => {
                 // event contains the event channel & data
                 // ie. channel outputs "KaChing.render.complete"
                 // ie. data outputs "{ format: 'video', url: 'http://the-vast-tag-url' }"

                 if (!event.isEmpty && event.detail && event.detail.identifier && !isVideoArticle) {
                     let slotElementId = event.detail.identifier;
                     let slotContainer = $(`#${slotElementId}-container`);
                     let articlePageContent = $(".article-page-content");
                     slotContainer.addClass("loaded");

                     // If pos 3 ad is overlapping content article content :
                     // - add a minimum height to the article to avoid ads to overlap social comments or other stuff
                     // - make all overlapping contents fit the page width
                     if (articlePageContent.length > 0 && MediaQueries.isDesktopHalfpageAdTreshold() && slotElementId.indexOf("rectangle-b1") >= 0) {
                         articlePageContent.css("min-height", slotContainer.outerHeight(true) + slotContainer.position().top);

                         $(".article-page-content .article-item--full, " +
                             ".article-page-content .article-item--inline-left," +
                             ".article-page-content .article-item--inline-right," +
                             ".article-page-content .article-item--normal, " +
                             ".article-page-content .article-item--normal--lg-up, " +
                             ".article-page-content .blockquote-right, " +
                             ".article-page-content .context-box--right")
                             .each(function () {
                                 let articleItem = $(this);
                                 if (articleItem.attr("class").indexOf("article-picture--portrait") >= 0) {
                                     return;
                                 }

                                 if (articleItem.offset().top <= slotContainer.offset().top + slotContainer.height()) {
                                     articleItem.removeClass("article-item--full article-item--normal");
                                     articleItem.addClass("article-item--fit");

                                 }
                             })
                     }
                 }
             })
//
//             // push to cmd array (cmd = Reference to the global command queue for asynchronous execution of GPT-related calls.)
//             googletag.cmd.push(function () {
//
//                 ads_debug("slotsToDisplay", slotsToDisplay);
//                 ads_debug("slotsToLazyLoad", slotsToLazyLoad);
//
//                 // define slots
//                 slotsToDisplay.forEach(s => {
//                     definedSlotsById[s.id] = s.defineSlot();
//                 });
//                 googletag.setAdIframeTitle('ad');
//                 googletag.pubads().setCentering(true);
//                 googletag.pubads().enableSingleRequest();
//                 googletag.pubads().disableInitialLoad();
//                 googletag.enableServices();
//
//                 // Display ads and refresh ads that don't need lazy loading, start lazy load ads
//
//                 slotsToDisplay.forEach(s => googletag.display(s.id));
//                 googletag.pubads().refresh();
//                 slotsToDisplay.forEach(s => {
//                     // a11y
//                     $('#'+s.id+ ' iframe').attr('tabindex', '-1');
//                 });
//                 // Add "loaded" class once the add has been loaded
//                 googletag.pubads().addEventListener('slotRenderEnded', function(event) {
//                     if(!event.isEmpty) {
//                         let slotElementId = event.slot.getSlotElementId();
//                         let slotContainer = $(`#${slotElementId}-container`);
//                         let articlePageContent = $(".article-page-content");
//                         slotContainer.addClass("loaded");
//
//                         // If pos 3 ad is overlapping content article content :
//                         // - add a minimum height to the article to avoid ads to overlap social comments or other stuff
//                         // - make all overlapping contents fit the page width
//                         if(articlePageContent.length > 0 && MediaQueries.isDesktopHalfpageAdTreshold() && slotElementId.indexOf("halfpage-3") >= 0) {
//                             articlePageContent.css("min-height", slotContainer.outerHeight(true) + slotContainer.position().top);
//
//                             $(".article-page-content .article-item--full, " +
//                                 ".article-page-content .article-item--inline-left," +
//                                 ".article-page-content .article-item--inline-right," +
//                                 ".article-page-content .article-item--normal, " +
//                                 ".article-page-content .article-item--normal--lg-up, " +
//                                 ".article-page-content .blockquote-right, " +
//                                 ".article-page-content .context-box--right")
//                                 .each(function () {
//                                     let articleItem = $(this);
//                                     if(articleItem.attr("class").indexOf("article-picture--portrait") >= 0) {
//                                         return;
//                                     }
//
//                                     if(articleItem.offset().top <= slotContainer.offset().top + slotContainer.height()) {
//                                         articleItem.removeClass("article-item--full article-item--normal");
//                                         articleItem.addClass("article-item--fit");
//                                     }
//                                 });
//                         }
//                     }
//                 });
//
//                 // lazy load ads
//                 lazyLoadAds();
//             });
         }
//
//
//         var lastWindowWidth = $(window).width();
//
//         $(window).smartresize(function() {
//             if(lastWindowWidth !== $(window).width()) {
//                 // refresh only already loaded ads
//                 ads_debug("refresh triggered")
//                 for (var k in definedSlotsById) {
//                     googletag.cmd.push(function() {
//                         ads_debug("refresh", k);
//                         googletag.pubads().refresh([definedSlotsById[k]]);
//                         // a11y
//                         $('#'+k+ ' iframe').attr('tabindex', '-1');
//                     });
//                 }
//
//                 lastWindowWidth = $(window).width();
//             }
//         });
 });



// WEBPACK FOOTER //
// ./js/ads/main.js